import { Tooltip, Typography } from '@mui/material';
import { formatDateLitteral } from 'helpers/format';
import moment from 'moment';
import React from 'react';

type EndDateCellProps = {
  end_date?: string | Date;
};
const EndDateCell = React.memo((row: EndDateCellProps) => {
  if (!row?.end_date) return null;

  const formattedDate = formatDateLitteral(moment.utc(row?.end_date).format('YYYY/MM/DD'));

  return (
    <Tooltip title={formattedDate}>
      <Typography variant="body2" noWrap>
        {formattedDate}
      </Typography>
    </Tooltip>
  );
});

export default EndDateCell;
